import React from 'react'
import {_GPY,__GPYGet} from '../../env.js'
import GpyModalAlert from '../gametypes/lib/GpyModalAlert'

class ServerPing extends React.Component {

  constructor (props) {
	    super(props)
	    this.state = {
        lastTime: 0,
			  network: true,
			  eventHandler: {},
	    };
	}

	registerEvent(name,e) {
		var ev = this.state.eventHandler;
    ev[name] = e;
    this.setState({eventHandler:ev});
	}

  showModal(obj){
		Object.keys(this.state.eventHandler).forEach(key => {
				var c = this.state.eventHandler[key];
				if(c !== undefined && c.showModal !== undefined){
					c.showModal(obj);
				}
		});
	}

  ping () {
    var t = new Date().getTime();
    __GPYGet('ping',(result) => {

      var diff = new Date().getTime() - t
      this.setState({lastTime: diff})
      if (!this.state.network ) {
         this.setState({network: true})
         this.showModal(false);
         clearInterval(this.interval);
         this.interval = setInterval(() => this.ping(), (15 * 1000));
      }

    },(error) => {
        console.log(error);
        this.setState({lastTime: -1})
        if (this.state.network) {
            clearInterval(this.interval)
            this.setState({network: false})
            this.showModal(true);
            this.interval = setInterval(() => this.ping(), (1 * 1000))
        }

    });
  }

  componentDidMount () {
    this.ping();
    this.interval = setInterval(() => this.ping(), (15 * 1000))
  }

  render () {
    var displayMillis = function (t) {
      if (t < 250) {
        return (<span className='text-success'>{t}ms</span>)
      } else if (t < 500) {
        return (<span className='text-warning'><span className="glyphicon glyphicon-alert" aria-hidden="true"></span> {t}ms</span>)
      } else {
        return (<span className='text-danger'><span className="glyphicon glyphicon-warning-sign" aria-hidden="true"></span> {t}ms</span>)
 		 }
	 }

	 return (<div>{displayMillis(this.state.lastTime)}
		          <GpyModalAlert title={_GPY.i18n.get('network_unreachable_modal_title')} parent={this} body={_GPY.i18n.get('network_unreachable_modal_body')} />
		       </div>);
  }
}
export default ServerPing
